import React, { useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import FolderOffOutlinedIcon from "@mui/icons-material/FolderOffOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { HEADER_ICON_SX } from "./entityCardChrome";

/**
 * The "Move to project" button in a card's header band: a folder icon that
 * opens the list of projects, the current one ticked, "No project" first.
 * Picking an entry calls ``onMove(projectId | null)``. Renders nothing when
 * no project list was given (a page without projects).
 */
export default function ProjectMenuButton({ projects, currentProjectId, onMove, itemLabel }) {
    const [anchor, setAnchor] = useState(null);
    if (!Array.isArray(projects)) return null;
    const close = () => setAnchor(null);
    const choose = (projectId) => {
        close();
        if ((projectId || null) !== (currentProjectId || null)) onMove(projectId);
    };
    const label = `Move ${itemLabel || "item"} to project`;
    return (
        <>
            <Tooltip title={label}>
                <IconButton
                    size="small"
                    aria-label={label}
                    aria-haspopup="menu"
                    onClick={(event) => setAnchor(event.currentTarget)}
                    sx={HEADER_ICON_SX}
                >
                    <FolderOutlinedIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={close}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MenuItem onClick={() => choose(null)} selected={!currentProjectId} dense>
                    <ListItemIcon>
                        {currentProjectId
                            ? <FolderOffOutlinedIcon fontSize="small" />
                            : <CheckIcon fontSize="small" />}
                    </ListItemIcon>
                    <ListItemText primary="No project" />
                </MenuItem>
                {projects.map((project) => {
                    const current = project.id === currentProjectId;
                    return (
                        <MenuItem key={project.id} onClick={() => choose(project.id)} selected={current} dense>
                            <ListItemIcon>
                                {current ? <CheckIcon fontSize="small" /> : <FolderOutlinedIcon fontSize="small" />}
                            </ListItemIcon>
                            <ListItemText primary={project.name} />
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}
